const closeDropdowns = (e, setter, element) => {
  if(!element?.current?.contains(e.target)){
    setter(false);
  }
}

export default closeDropdowns;
